import { injectable, inject } from "inversify";
import { IF360Validator } from "../F360Validator";
import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import { type IStorage } from "@/core/plugins/storage/Storage";

import "reflect-metadata";

@injectable()
export default class SysAdminValidator implements IF360Validator {
  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  handleValidation(): boolean {
    const roles = this.storage.get(LocalStorageKeys.userRules);

    return roles?.includes("sysAdmin") || false;
  }
}
